import { Drawer } from "./drawer";
customElements.define("uwp-drawer", Drawer);
